import { DateTime } from 'luxon';

/**
 * The first day after the trial period: the earliest effective date for the permanent modification and the due
 * date of the first modified payment. For a 0-month trial this is the trial start date itself.
 */
export const getFlexModTrialEndDate = (trialStartDate: Date, trialTermMonths: number): Date =>
  DateTime.fromJSDate(trialStartDate).plus({ months: trialTermMonths }).toJSDate();
